import i18next from 'i18next';

i18next.addResources('es_CL', 'AddCardFailure', {
  title: 'Tu tarjeta no se pudo procesar',
  message: 'Hubo un problema técnico al agregar tu tarjeta, por favor inténtalo de nuevo.',
  button: 'Volver a intentar'
});
